/**
 * Deep links into Stripe's dashboard for objects owned by a connected account.
 *
 * Both accounts are in the path: the platform account this stage's key belongs
 * to comes first (it differs per deployment), then the connected account under
 * `connect/accounts`, which is the view staff get when they drill into a
 * merchant. Test-mode objects sit behind a `/test` segment right after the
 * platform account; live mode has no such segment.
 *
 *   https://dashboard.stripe.com/{platform}/test/connect/accounts/{connected}/payments/{pi}
 *   https://dashboard.stripe.com/{platform}/connect/accounts/{connected}/payments/{pi}
 */
function connectedAccountUrl(args: {
  platformAccountId: string;
  stripeAccountId: string;
  mode: "live" | "test";
  path: string;
}): string {
  const mode = args.mode === "test" ? "/test" : "";
  return `https://dashboard.stripe.com/${args.platformAccountId}${mode}/connect/accounts/${args.stripeAccountId}/${args.path}`;
}

/**
 * The disputed payment on the connected account. A dispute is reviewed and
 * answered from its payment's page, which is also the only dispute route Stripe
 * documents for the connected-account view.
 */
export function stripeDisputedPaymentUrl(args: {
  platformAccountId: string;
  stripeAccountId: string;
  mode: "live" | "test";
  paymentId: string;
}): string {
  return connectedAccountUrl({ ...args, path: `payments/${args.paymentId}` });
}
